import React from 'react'
import styled from 'styled-components'

export const MatchHighlight = styled.mark`
  background: #fde68a;
  color: inherit;
  padding: 0;
  border-radius: 2px;
`

const COMBINING_MARKS = /[̀-ͯ]/g

const normalize = (s: string) =>
  s.normalize('NFD').replace(COMBINING_MARKS, '').toLowerCase()

export const highlightMatch = (
  text: string,
  query: string
): React.ReactNode => {
  if (!query) return text

  const normText = normalize(text)
  const normQuery = normalize(query)
  const matchStart = normText.indexOf(normQuery)

  if (matchStart === -1) return text

  // Map normalized index back to original string. NFD decomposition can make
  // the normalized string longer, so we walk it to find the right position.
  const nfd = text.normalize('NFD')
  let origStart = 0
  let origEnd = 0
  let ni = 0

  for (let i = 0; i <= nfd.length; i++) {
    if (
      i < nfd.length &&
      nfd.charCodeAt(i) >= 0x0300 &&
      nfd.charCodeAt(i) <= 0x036f
    ) {
      continue
    }
    if (ni === matchStart) origStart = i
    if (ni === matchStart + normQuery.length) {
      origEnd = i
      break
    }
    ni++
  }

  const before = nfd.slice(0, origStart).normalize('NFC')
  const match = nfd.slice(origStart, origEnd).normalize('NFC')
  const after = nfd.slice(origEnd).normalize('NFC')

  return (
    <>
      {before}
      <MatchHighlight>{match}</MatchHighlight>
      {after}
    </>
  )
}
